import { LayoutHOC } from 'base/ui/layout/layout';
import { IServices } from 'services/services';
import createWasteHandoverPlan from '.';
import createWasteHandoverPlanDetail from './CreateUpdate';
import createUpdateWasteHandoverPlan from './UpdatePlan';
import { createCreateUpdateWasteHandoverRegistration } from '../wasteHandoverRegistration/CreateUpdate/createUpdateWasteHandoverRegistration';
import { wasteHandoverPlanRoutes } from './routes';

export const createWasteHandoverPlanPage = (layoutHOC: LayoutHOC, services: IServices) => {
  const List = createWasteHandoverPlan();
  const Create = createWasteHandoverPlanDetail();
  const Update = createUpdateWasteHandoverPlan();
  const Copy = createWasteHandoverPlanDetail();


  const WasteHandoverPlanPage = wasteHandoverPlanRoutes;
  return layoutHOC(() => <WasteHandoverPlanPage List={List} Create={Create}
    Update={Update} Copy={Copy} />);
};

